import { DeleteSavedBasket } from "../../../Services/BasketService"
import { toast } from "react-toastify"
import { useAuth } from "../../../Providers/AuthProvider"
import { useConfig } from "../../../Providers/ConfigProvider"

const useDeleteSavedBasket = () => {
    const { authState } = useAuth()

    const { api } = useConfig()

    const handleDeleteSavedBasket = async (basketId) => {
        await DeleteSavedBasket(api, basketId).then(res => {
            return true
        }).catch(e => {
            console.log(e)
            toast.error('Nie udało się usunąć koszyka!')
            return false
        })
    }

    return { handleDeleteSavedBasket }
}

export default useDeleteSavedBasket